module.exports = __webpack_public_path__ + "img/players.d470c685.svg";